/* tslint:disable */
/* eslint-disable */
/**
 * hr-report backend
 * hr-report backend
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kanya384@mail.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AuthSignInRequest
 */
export interface AuthSignInRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthSignInRequest
     */
    'login'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthSignInRequest
     */
    'pass'?: string;
}
/**
 * 
 * @export
 * @interface AuthSignInResponse
 */
export interface AuthSignInResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthSignInResponse
     */
    'refreshToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthSignInResponse
     */
    'token'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DomainUploadStatus = {
    Created: 'created',
    Approved: 'approved',
    Pending: 'pending',
    Done: 'done'
} as const;

export type DomainUploadStatus = typeof DomainUploadStatus[keyof typeof DomainUploadStatus];


/**
 * 
 * @export
 * @interface LandingCreateLandingRequest
 */
export interface LandingCreateLandingRequest {
    /**
     * 
     * @type {number}
     * @memberof LandingCreateLandingRequest
     */
    'big_image_width'?: number;
    /**
     * 
     * @type {string}
     * @memberof LandingCreateLandingRequest
     */
    'domain'?: string;
    /**
     * 
     * @type {string}
     * @memberof LandingCreateLandingRequest
     */
    'images_path'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LandingCreateLandingRequest
     */
    'is_with_thumb'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LandingCreateLandingRequest
     */
    'thumb_height'?: number;
    /**
     * 
     * @type {string}
     * @memberof LandingCreateLandingRequest
     */
    'thumb_postfix'?: string;
    /**
     * 
     * @type {number}
     * @memberof LandingCreateLandingRequest
     */
    'thumb_width'?: number;
}
/**
 * 
 * @export
 * @interface LandingLandingResponse
 */
export interface LandingLandingResponse {
    /**
     * 
     * @type {number}
     * @memberof LandingLandingResponse
     */
    'big_image_width'?: number;
    /**
     * 
     * @type {string}
     * @memberof LandingLandingResponse
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof LandingLandingResponse
     */
    'domain'?: string;
    /**
     * 
     * @type {string}
     * @memberof LandingLandingResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LandingLandingResponse
     */
    'images_path'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LandingLandingResponse
     */
    'is_with_thumb'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LandingLandingResponse
     */
    'modified_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof LandingLandingResponse
     */
    'thumb_height'?: number;
    /**
     * 
     * @type {string}
     * @memberof LandingLandingResponse
     */
    'thumb_postfix'?: string;
    /**
     * 
     * @type {number}
     * @memberof LandingLandingResponse
     */
    'thumb_width'?: number;
}
/**
 * 
 * @export
 * @interface LandingUpdateLandingRequest
 */
export interface LandingUpdateLandingRequest {
    /**
     * 
     * @type {number}
     * @memberof LandingUpdateLandingRequest
     */
    'big_image_width'?: number;
    /**
     * 
     * @type {string}
     * @memberof LandingUpdateLandingRequest
     */
    'domain'?: string;
    /**
     * 
     * @type {string}
     * @memberof LandingUpdateLandingRequest
     */
    'images_path'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LandingUpdateLandingRequest
     */
    'is_with_thumb'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LandingUpdateLandingRequest
     */
    'thumb_height'?: number;
    /**
     * 
     * @type {string}
     * @memberof LandingUpdateLandingRequest
     */
    'thumb_postfix'?: string;
    /**
     * 
     * @type {number}
     * @memberof LandingUpdateLandingRequest
     */
    'thumb_width'?: number;
}
/**
 * 
 * @export
 * @interface RestErrorResponse
 */
export interface RestErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof RestErrorResponse
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface UploadTaskCreateUploadTaskRequest
 */
export interface UploadTaskCreateUploadTaskRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UploadTaskCreateUploadTaskRequest
     */
    'image_order'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof UploadTaskCreateUploadTaskRequest
     */
    'month'?: number;
    /**
     * 
     * @type {string}
     * @memberof UploadTaskCreateUploadTaskRequest
     */
    'site_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadTaskCreateUploadTaskRequest
     */
    'tmp_folder'?: string;
    /**
     * 
     * @type {DomainUploadStatus}
     * @memberof UploadTaskCreateUploadTaskRequest
     */
    'upload_status'?: DomainUploadStatus;
    /**
     * 
     * @type {number}
     * @memberof UploadTaskCreateUploadTaskRequest
     */
    'year'?: number;
}
/**
 * 
 * @export
 * @interface UploadTaskUpdateUploadTaskRequest
 */
export interface UploadTaskUpdateUploadTaskRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UploadTaskUpdateUploadTaskRequest
     */
    'image_order'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof UploadTaskUpdateUploadTaskRequest
     */
    'month'?: number;
    /**
     * 
     * @type {string}
     * @memberof UploadTaskUpdateUploadTaskRequest
     */
    'site_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadTaskUpdateUploadTaskRequest
     */
    'tmp_folder'?: string;
    /**
     * 
     * @type {DomainUploadStatus}
     * @memberof UploadTaskUpdateUploadTaskRequest
     */
    'upload_status'?: DomainUploadStatus;
    /**
     * 
     * @type {number}
     * @memberof UploadTaskUpdateUploadTaskRequest
     */
    'year'?: number;
}
/**
 * 
 * @export
 * @interface UploadTaskUploadTaskResponse
 */
export interface UploadTaskUploadTaskResponse {
    /**
     * 
     * @type {string}
     * @memberof UploadTaskUploadTaskResponse
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadTaskUploadTaskResponse
     */
    'id'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UploadTaskUploadTaskResponse
     */
    'image_order'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UploadTaskUploadTaskResponse
     */
    'modified_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof UploadTaskUploadTaskResponse
     */
    'month'?: number;
    /**
     * 
     * @type {string}
     * @memberof UploadTaskUploadTaskResponse
     */
    'site_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadTaskUploadTaskResponse
     */
    'tmp_folder'?: string;
    /**
     * 
     * @type {DomainUploadStatus}
     * @memberof UploadTaskUploadTaskResponse
     */
    'upload_status'?: DomainUploadStatus;
    /**
     * 
     * @type {number}
     * @memberof UploadTaskUploadTaskResponse
     */
    'year'?: number;
}
/**
 * 
 * @export
 * @interface UploadTaskYear
 */
export interface UploadTaskYear {
    /**
     * 
     * @type {Array<number>}
     * @memberof UploadTaskYear
     */
    'months'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof UploadTaskYear
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @interface UserChangePasswordRequest
 */
export interface UserChangePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof UserChangePasswordRequest
     */
    'password'?: string;
}
/**
 * 
 * @export
 * @interface UserCreateUserRequest
 */
export interface UserCreateUserRequest {
    /**
     * 
     * @type {string}
     * @memberof UserCreateUserRequest
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateUserRequest
     */
    'login'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateUserRequest
     */
    'modified_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateUserRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateUserRequest
     */
    'pass'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateUserRequest
     */
    'role'?: string;
}
/**
 * 
 * @export
 * @interface UserUpdateUserRequest
 */
export interface UserUpdateUserRequest {
    /**
     * 
     * @type {string}
     * @memberof UserUpdateUserRequest
     */
    'login'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateUserRequest
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface UserUserResponse
 */
export interface UserUserResponse {
    /**
     * 
     * @type {string}
     * @memberof UserUserResponse
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserResponse
     */
    'login'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserResponse
     */
    'modified_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserResponse
     */
    'pass'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserResponse
     */
    'role'?: string;
}

/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * авторизация пользователя.
         * @summary авторизация пользователя.
         * @param {AuthSignInRequest} user Данные для аутентификации
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthSignInPost: async (user: AuthSignInRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'user' is not null or undefined
            assertParamExists('apiAuthSignInPost', 'user', user)
            const localVarPath = `/api/auth/sign-in`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(user, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * авторизация пользователя.
         * @summary авторизация пользователя.
         * @param {AuthSignInRequest} user Данные для аутентификации
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthSignInPost(user: AuthSignInRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthSignInResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthSignInPost(user, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * авторизация пользователя.
         * @summary авторизация пользователя.
         * @param {AuthSignInRequest} user Данные для аутентификации
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthSignInPost(user: AuthSignInRequest, options?: any): AxiosPromise<AuthSignInResponse> {
            return localVarFp.apiAuthSignInPost(user, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * авторизация пользователя.
     * @summary авторизация пользователя.
     * @param {AuthSignInRequest} user Данные для аутентификации
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiAuthSignInPost(user: AuthSignInRequest, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthSignInPost(user, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LandingsApi - axios parameter creator
 * @export
 */
export const LandingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * получить список всех landing.
         * @summary получить список всех landing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLandingGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/landing/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * удалить landing
         * @summary удалить landing
         * @param {string} id Идентификатор landing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLandingIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiLandingIdDelete', 'id', id)
            const localVarPath = `/api/landing/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * получить landing по id.
         * @summary получить landing по id.
         * @param {string} id Идентификатор landing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLandingIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiLandingIdGet', 'id', id)
            const localVarPath = `/api/landing/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * обновление landing.
         * @summary обновление landing.
         * @param {string} id Идентификатор landing
         * @param {LandingUpdateLandingRequest} landing Данные для обновления landing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLandingIdPut: async (id: string, landing: LandingUpdateLandingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiLandingIdPut', 'id', id)
            // verify required parameter 'landing' is not null or undefined
            assertParamExists('apiLandingIdPut', 'landing', landing)
            const localVarPath = `/api/landing/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(landing, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * создание landing.
         * @summary создание landing.
         * @param {LandingCreateLandingRequest} landing Данные landing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLandingPost: async (landing: LandingCreateLandingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'landing' is not null or undefined
            assertParamExists('apiLandingPost', 'landing', landing)
            const localVarPath = `/api/landing/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(landing, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LandingsApi - functional programming interface
 * @export
 */
export const LandingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LandingsApiAxiosParamCreator(configuration)
    return {
        /**
         * получить список всех landing.
         * @summary получить список всех landing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLandingGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LandingLandingResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLandingGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * удалить landing
         * @summary удалить landing
         * @param {string} id Идентификатор landing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLandingIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LandingLandingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLandingIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * получить landing по id.
         * @summary получить landing по id.
         * @param {string} id Идентификатор landing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLandingIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LandingLandingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLandingIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * обновление landing.
         * @summary обновление landing.
         * @param {string} id Идентификатор landing
         * @param {LandingUpdateLandingRequest} landing Данные для обновления landing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLandingIdPut(id: string, landing: LandingUpdateLandingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LandingLandingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLandingIdPut(id, landing, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * создание landing.
         * @summary создание landing.
         * @param {LandingCreateLandingRequest} landing Данные landing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLandingPost(landing: LandingCreateLandingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LandingLandingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLandingPost(landing, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LandingsApi - factory interface
 * @export
 */
export const LandingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LandingsApiFp(configuration)
    return {
        /**
         * получить список всех landing.
         * @summary получить список всех landing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLandingGet(options?: any): AxiosPromise<Array<LandingLandingResponse>> {
            return localVarFp.apiLandingGet(options).then((request) => request(axios, basePath));
        },
        /**
         * удалить landing
         * @summary удалить landing
         * @param {string} id Идентификатор landing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLandingIdDelete(id: string, options?: any): AxiosPromise<LandingLandingResponse> {
            return localVarFp.apiLandingIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * получить landing по id.
         * @summary получить landing по id.
         * @param {string} id Идентификатор landing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLandingIdGet(id: string, options?: any): AxiosPromise<LandingLandingResponse> {
            return localVarFp.apiLandingIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * обновление landing.
         * @summary обновление landing.
         * @param {string} id Идентификатор landing
         * @param {LandingUpdateLandingRequest} landing Данные для обновления landing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLandingIdPut(id: string, landing: LandingUpdateLandingRequest, options?: any): AxiosPromise<LandingLandingResponse> {
            return localVarFp.apiLandingIdPut(id, landing, options).then((request) => request(axios, basePath));
        },
        /**
         * создание landing.
         * @summary создание landing.
         * @param {LandingCreateLandingRequest} landing Данные landing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLandingPost(landing: LandingCreateLandingRequest, options?: any): AxiosPromise<LandingLandingResponse> {
            return localVarFp.apiLandingPost(landing, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LandingsApi - object-oriented interface
 * @export
 * @class LandingsApi
 * @extends {BaseAPI}
 */
export class LandingsApi extends BaseAPI {
    /**
     * получить список всех landing.
     * @summary получить список всех landing.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandingsApi
     */
    public apiLandingGet(options?: AxiosRequestConfig) {
        return LandingsApiFp(this.configuration).apiLandingGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * удалить landing
     * @summary удалить landing
     * @param {string} id Идентификатор landing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandingsApi
     */
    public apiLandingIdDelete(id: string, options?: AxiosRequestConfig) {
        return LandingsApiFp(this.configuration).apiLandingIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * получить landing по id.
     * @summary получить landing по id.
     * @param {string} id Идентификатор landing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandingsApi
     */
    public apiLandingIdGet(id: string, options?: AxiosRequestConfig) {
        return LandingsApiFp(this.configuration).apiLandingIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * обновление landing.
     * @summary обновление landing.
     * @param {string} id Идентификатор landing
     * @param {LandingUpdateLandingRequest} landing Данные для обновления landing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandingsApi
     */
    public apiLandingIdPut(id: string, landing: LandingUpdateLandingRequest, options?: AxiosRequestConfig) {
        return LandingsApiFp(this.configuration).apiLandingIdPut(id, landing, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * создание landing.
     * @summary создание landing.
     * @param {LandingCreateLandingRequest} landing Данные landing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandingsApi
     */
    public apiLandingPost(landing: LandingCreateLandingRequest, options?: AxiosRequestConfig) {
        return LandingsApiFp(this.configuration).apiLandingPost(landing, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UploadTasksApi - axios parameter creator
 * @export
 */
export const UploadTasksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * получить список всех uploadTask.
         * @summary получить список всех uploadTask.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUploadTaskGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/upload-task/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * удалить uploadTask
         * @summary удалить uploadTask
         * @param {string} id Идентификатор uploadTask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUploadTaskIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUploadTaskIdDelete', 'id', id)
            const localVarPath = `/api/upload-task/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * получить uploadTask по id.
         * @summary получить uploadTask по id.
         * @param {string} id Идентификатор uploadTask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUploadTaskIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUploadTaskIdGet', 'id', id)
            const localVarPath = `/api/upload-task/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * получить картирнку из url.
         * @summary получить картирнку из url.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUploadTaskIdImageYearMonthFilenamePost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/upload-task/{id}/image/{year}/{month}/{filename}`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * обновление uploadTask.
         * @summary обновление uploadTask.
         * @param {string} id Идентификатор uploadTask
         * @param {UploadTaskUpdateUploadTaskRequest} uploadTask Данные для обновления uploadTask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUploadTaskIdPut: async (id: string, uploadTask: UploadTaskUpdateUploadTaskRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUploadTaskIdPut', 'id', id)
            // verify required parameter 'uploadTask' is not null or undefined
            assertParamExists('apiUploadTaskIdPut', 'uploadTask', uploadTask)
            const localVarPath = `/api/upload-task/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadTask, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * получить дерево хода строительства.
         * @summary получить дерево хода строительства.
         * @param {string} id Идентификатор сайта
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUploadTaskIdTreeGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUploadTaskIdTreeGet', 'id', id)
            const localVarPath = `/api/upload-task/{id}/tree`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * получить дерево хода строительства.
         * @summary получить дерево хода строительства.
         * @param {string} id Идентификатор сайта
         * @param {string} year Год
         * @param {string} month Месяц
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUploadTaskIdTreeYearMonthGet: async (id: string, year: string, month: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUploadTaskIdTreeYearMonthGet', 'id', id)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('apiUploadTaskIdTreeYearMonthGet', 'year', year)
            // verify required parameter 'month' is not null or undefined
            assertParamExists('apiUploadTaskIdTreeYearMonthGet', 'month', month)
            const localVarPath = `/api/upload-task/{id}/tree/{year}/{month}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"month"}}`, encodeURIComponent(String(month)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * создание uploadTask.
         * @summary создание uploadTask.
         * @param {UploadTaskCreateUploadTaskRequest} uploadTask Данные uploadTask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUploadTaskPost: async (uploadTask: UploadTaskCreateUploadTaskRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadTask' is not null or undefined
            assertParamExists('apiUploadTaskPost', 'uploadTask', uploadTask)
            const localVarPath = `/api/upload-task/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadTask, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UploadTasksApi - functional programming interface
 * @export
 */
export const UploadTasksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UploadTasksApiAxiosParamCreator(configuration)
    return {
        /**
         * получить список всех uploadTask.
         * @summary получить список всех uploadTask.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUploadTaskGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UploadTaskUploadTaskResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUploadTaskGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * удалить uploadTask
         * @summary удалить uploadTask
         * @param {string} id Идентификатор uploadTask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUploadTaskIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadTaskUploadTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUploadTaskIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * получить uploadTask по id.
         * @summary получить uploadTask по id.
         * @param {string} id Идентификатор uploadTask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUploadTaskIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadTaskUploadTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUploadTaskIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * получить картирнку из url.
         * @summary получить картирнку из url.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUploadTaskIdImageYearMonthFilenamePost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUploadTaskIdImageYearMonthFilenamePost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * обновление uploadTask.
         * @summary обновление uploadTask.
         * @param {string} id Идентификатор uploadTask
         * @param {UploadTaskUpdateUploadTaskRequest} uploadTask Данные для обновления uploadTask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUploadTaskIdPut(id: string, uploadTask: UploadTaskUpdateUploadTaskRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadTaskUploadTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUploadTaskIdPut(id, uploadTask, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * получить дерево хода строительства.
         * @summary получить дерево хода строительства.
         * @param {string} id Идентификатор сайта
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUploadTaskIdTreeGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UploadTaskYear>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUploadTaskIdTreeGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * получить дерево хода строительства.
         * @summary получить дерево хода строительства.
         * @param {string} id Идентификатор сайта
         * @param {string} year Год
         * @param {string} month Месяц
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUploadTaskIdTreeYearMonthGet(id: string, year: string, month: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUploadTaskIdTreeYearMonthGet(id, year, month, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * создание uploadTask.
         * @summary создание uploadTask.
         * @param {UploadTaskCreateUploadTaskRequest} uploadTask Данные uploadTask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUploadTaskPost(uploadTask: UploadTaskCreateUploadTaskRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadTaskUploadTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUploadTaskPost(uploadTask, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UploadTasksApi - factory interface
 * @export
 */
export const UploadTasksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UploadTasksApiFp(configuration)
    return {
        /**
         * получить список всех uploadTask.
         * @summary получить список всех uploadTask.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUploadTaskGet(options?: any): AxiosPromise<Array<UploadTaskUploadTaskResponse>> {
            return localVarFp.apiUploadTaskGet(options).then((request) => request(axios, basePath));
        },
        /**
         * удалить uploadTask
         * @summary удалить uploadTask
         * @param {string} id Идентификатор uploadTask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUploadTaskIdDelete(id: string, options?: any): AxiosPromise<UploadTaskUploadTaskResponse> {
            return localVarFp.apiUploadTaskIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * получить uploadTask по id.
         * @summary получить uploadTask по id.
         * @param {string} id Идентификатор uploadTask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUploadTaskIdGet(id: string, options?: any): AxiosPromise<UploadTaskUploadTaskResponse> {
            return localVarFp.apiUploadTaskIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * получить картирнку из url.
         * @summary получить картирнку из url.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUploadTaskIdImageYearMonthFilenamePost(options?: any): AxiosPromise<File> {
            return localVarFp.apiUploadTaskIdImageYearMonthFilenamePost(options).then((request) => request(axios, basePath));
        },
        /**
         * обновление uploadTask.
         * @summary обновление uploadTask.
         * @param {string} id Идентификатор uploadTask
         * @param {UploadTaskUpdateUploadTaskRequest} uploadTask Данные для обновления uploadTask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUploadTaskIdPut(id: string, uploadTask: UploadTaskUpdateUploadTaskRequest, options?: any): AxiosPromise<UploadTaskUploadTaskResponse> {
            return localVarFp.apiUploadTaskIdPut(id, uploadTask, options).then((request) => request(axios, basePath));
        },
        /**
         * получить дерево хода строительства.
         * @summary получить дерево хода строительства.
         * @param {string} id Идентификатор сайта
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUploadTaskIdTreeGet(id: string, options?: any): AxiosPromise<Array<UploadTaskYear>> {
            return localVarFp.apiUploadTaskIdTreeGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * получить дерево хода строительства.
         * @summary получить дерево хода строительства.
         * @param {string} id Идентификатор сайта
         * @param {string} year Год
         * @param {string} month Месяц
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUploadTaskIdTreeYearMonthGet(id: string, year: string, month: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.apiUploadTaskIdTreeYearMonthGet(id, year, month, options).then((request) => request(axios, basePath));
        },
        /**
         * создание uploadTask.
         * @summary создание uploadTask.
         * @param {UploadTaskCreateUploadTaskRequest} uploadTask Данные uploadTask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUploadTaskPost(uploadTask: UploadTaskCreateUploadTaskRequest, options?: any): AxiosPromise<UploadTaskUploadTaskResponse> {
            return localVarFp.apiUploadTaskPost(uploadTask, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UploadTasksApi - object-oriented interface
 * @export
 * @class UploadTasksApi
 * @extends {BaseAPI}
 */
export class UploadTasksApi extends BaseAPI {
    /**
     * получить список всех uploadTask.
     * @summary получить список всех uploadTask.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadTasksApi
     */
    public apiUploadTaskGet(options?: AxiosRequestConfig) {
        return UploadTasksApiFp(this.configuration).apiUploadTaskGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * удалить uploadTask
     * @summary удалить uploadTask
     * @param {string} id Идентификатор uploadTask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadTasksApi
     */
    public apiUploadTaskIdDelete(id: string, options?: AxiosRequestConfig) {
        return UploadTasksApiFp(this.configuration).apiUploadTaskIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * получить uploadTask по id.
     * @summary получить uploadTask по id.
     * @param {string} id Идентификатор uploadTask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadTasksApi
     */
    public apiUploadTaskIdGet(id: string, options?: AxiosRequestConfig) {
        return UploadTasksApiFp(this.configuration).apiUploadTaskIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * получить картирнку из url.
     * @summary получить картирнку из url.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadTasksApi
     */
    public apiUploadTaskIdImageYearMonthFilenamePost(options?: AxiosRequestConfig) {
        return UploadTasksApiFp(this.configuration).apiUploadTaskIdImageYearMonthFilenamePost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * обновление uploadTask.
     * @summary обновление uploadTask.
     * @param {string} id Идентификатор uploadTask
     * @param {UploadTaskUpdateUploadTaskRequest} uploadTask Данные для обновления uploadTask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadTasksApi
     */
    public apiUploadTaskIdPut(id: string, uploadTask: UploadTaskUpdateUploadTaskRequest, options?: AxiosRequestConfig) {
        return UploadTasksApiFp(this.configuration).apiUploadTaskIdPut(id, uploadTask, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * получить дерево хода строительства.
     * @summary получить дерево хода строительства.
     * @param {string} id Идентификатор сайта
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadTasksApi
     */
    public apiUploadTaskIdTreeGet(id: string, options?: AxiosRequestConfig) {
        return UploadTasksApiFp(this.configuration).apiUploadTaskIdTreeGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * получить дерево хода строительства.
     * @summary получить дерево хода строительства.
     * @param {string} id Идентификатор сайта
     * @param {string} year Год
     * @param {string} month Месяц
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadTasksApi
     */
    public apiUploadTaskIdTreeYearMonthGet(id: string, year: string, month: string, options?: AxiosRequestConfig) {
        return UploadTasksApiFp(this.configuration).apiUploadTaskIdTreeYearMonthGet(id, year, month, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * создание uploadTask.
     * @summary создание uploadTask.
     * @param {UploadTaskCreateUploadTaskRequest} uploadTask Данные uploadTask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadTasksApi
     */
    public apiUploadTaskPost(uploadTask: UploadTaskCreateUploadTaskRequest, options?: AxiosRequestConfig) {
        return UploadTasksApiFp(this.configuration).apiUploadTaskPost(uploadTask, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * получить список всех источников.
         * @summary получить список всех пользователей.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * удалить пользователя
         * @summary удалить пользователя
         * @param {string} id Идентификатор пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUserIdDelete', 'id', id)
            const localVarPath = `/api/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * получить платеж по id.
         * @summary получить платеж по id.
         * @param {string} id Идентификатор платежа
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUserIdGet', 'id', id)
            const localVarPath = `/api/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * смена пароля пользователя.
         * @summary смена пароля пользователя.
         * @param {string} id Идентификатор пользователя
         * @param {UserChangePasswordRequest} user Данные для обновления пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserIdPasswordPut: async (id: string, user: UserChangePasswordRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUserIdPasswordPut', 'id', id)
            // verify required parameter 'user' is not null or undefined
            assertParamExists('apiUserIdPasswordPut', 'user', user)
            const localVarPath = `/api/user/{id}/password`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(user, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * обновление пользователя.
         * @summary обновление пользователя.
         * @param {string} id Идентификатор пользователя
         * @param {UserUpdateUserRequest} user Данные для обновления пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserIdPut: async (id: string, user: UserUpdateUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUserIdPut', 'id', id)
            // verify required parameter 'user' is not null or undefined
            assertParamExists('apiUserIdPut', 'user', user)
            const localVarPath = `/api/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(user, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * создание пользователя.
         * @summary создание пользователя.
         * @param {UserCreateUserRequest} user Данные пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserPost: async (user: UserCreateUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'user' is not null or undefined
            assertParamExists('apiUserPost', 'user', user)
            const localVarPath = `/api/user/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(user, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * получить список всех источников.
         * @summary получить список всех пользователей.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserUserResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * удалить пользователя
         * @summary удалить пользователя
         * @param {string} id Идентификатор пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * получить платеж по id.
         * @summary получить платеж по id.
         * @param {string} id Идентификатор платежа
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * смена пароля пользователя.
         * @summary смена пароля пользователя.
         * @param {string} id Идентификатор пользователя
         * @param {UserChangePasswordRequest} user Данные для обновления пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserIdPasswordPut(id: string, user: UserChangePasswordRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserIdPasswordPut(id, user, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * обновление пользователя.
         * @summary обновление пользователя.
         * @param {string} id Идентификатор пользователя
         * @param {UserUpdateUserRequest} user Данные для обновления пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserIdPut(id: string, user: UserUpdateUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserIdPut(id, user, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * создание пользователя.
         * @summary создание пользователя.
         * @param {UserCreateUserRequest} user Данные пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserPost(user: UserCreateUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserPost(user, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * получить список всех источников.
         * @summary получить список всех пользователей.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserGet(options?: any): AxiosPromise<Array<UserUserResponse>> {
            return localVarFp.apiUserGet(options).then((request) => request(axios, basePath));
        },
        /**
         * удалить пользователя
         * @summary удалить пользователя
         * @param {string} id Идентификатор пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserIdDelete(id: string, options?: any): AxiosPromise<UserUserResponse> {
            return localVarFp.apiUserIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * получить платеж по id.
         * @summary получить платеж по id.
         * @param {string} id Идентификатор платежа
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserIdGet(id: string, options?: any): AxiosPromise<UserUserResponse> {
            return localVarFp.apiUserIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * смена пароля пользователя.
         * @summary смена пароля пользователя.
         * @param {string} id Идентификатор пользователя
         * @param {UserChangePasswordRequest} user Данные для обновления пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserIdPasswordPut(id: string, user: UserChangePasswordRequest, options?: any): AxiosPromise<UserUserResponse> {
            return localVarFp.apiUserIdPasswordPut(id, user, options).then((request) => request(axios, basePath));
        },
        /**
         * обновление пользователя.
         * @summary обновление пользователя.
         * @param {string} id Идентификатор пользователя
         * @param {UserUpdateUserRequest} user Данные для обновления пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserIdPut(id: string, user: UserUpdateUserRequest, options?: any): AxiosPromise<UserUserResponse> {
            return localVarFp.apiUserIdPut(id, user, options).then((request) => request(axios, basePath));
        },
        /**
         * создание пользователя.
         * @summary создание пользователя.
         * @param {UserCreateUserRequest} user Данные пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserPost(user: UserCreateUserRequest, options?: any): AxiosPromise<UserUserResponse> {
            return localVarFp.apiUserPost(user, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * получить список всех источников.
     * @summary получить список всех пользователей.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUserGet(options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUserGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * удалить пользователя
     * @summary удалить пользователя
     * @param {string} id Идентификатор пользователя
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUserIdDelete(id: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUserIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * получить платеж по id.
     * @summary получить платеж по id.
     * @param {string} id Идентификатор платежа
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUserIdGet(id: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUserIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * смена пароля пользователя.
     * @summary смена пароля пользователя.
     * @param {string} id Идентификатор пользователя
     * @param {UserChangePasswordRequest} user Данные для обновления пользователя
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUserIdPasswordPut(id: string, user: UserChangePasswordRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUserIdPasswordPut(id, user, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * обновление пользователя.
     * @summary обновление пользователя.
     * @param {string} id Идентификатор пользователя
     * @param {UserUpdateUserRequest} user Данные для обновления пользователя
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUserIdPut(id: string, user: UserUpdateUserRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUserIdPut(id, user, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * создание пользователя.
     * @summary создание пользователя.
     * @param {UserCreateUserRequest} user Данные пользователя
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUserPost(user: UserCreateUserRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUserPost(user, options).then((request) => request(this.axios, this.basePath));
    }
}


